import {t, Trans} from '@lingui/macro'

import {Referral} from '@pleo-io/telescope-pictograms'

import {AdoptionPrompt} from '@product-web/feature--help-centre/adoption-prompt'

import {useRouAdoption} from './use-rou-adoption-prompt'

export const RouAdoptionPrompt = () => {
    const {minSavingPercentage, shouldShowRouAdoptionPrompt, setRouAdoptionPromptViewed} =
        useRouAdoption()

    if (!shouldShowRouAdoptionPrompt) {
        return null
    }

    return (
        <RouAdoptionPromptPresentation
            saving={minSavingPercentage}
            setRouAdoptionPromptViewed={setRouAdoptionPromptViewed}
        />
    )
}

export const RouAdoptionPromptPresentation = ({
    saving,
    setRouAdoptionPromptViewed,
}: {
    saving: number
    setRouAdoptionPromptViewed: () => void
}) => {
    // TODO: enable navigate when rou landing page url is decided
    // const navigate = useNavigate()

    // TODO: enable tracking when its ready
    // useEffect(() => {
    //     trackRouAdoptionPromptActioned({action: 'viewed'})
    // }, [])
    return (
        <AdoptionPrompt
            title={<Trans>Get more employees using Pleo</Trans>}
            text={
                <Trans>
                    Improve visibility over spend and save up to {saving}% with reimbursement-only
                    packages.
                </Trans>
            }
            imageComponent={<Referral size="56" />}
            completeText={t`View offer`}
            dismissText={t`Not now`}
            name="rou-adoption-prompt"
            onComplete={() => {
                setRouAdoptionPromptViewed()
                // trackRouAdoptionPromptActioned({action: 'view_offer'})
                // TODO: enable navigate when rou landing page url is decided (BFR-1327)
                // navigate('/new-rou-landing-page-url')
            }}
            onDismiss={() => {
                setRouAdoptionPromptViewed()
                // trackRouAdoptionPromptActioned({action: 'not_now'})
            }}
            size="medium"
        />
    )
}
